import React from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import DanielLandingPage from './components/DanielLandingPage';

const theme = createTheme({
  direction: 'rtl',
  typography: {
    fontFamily: 'Heebo, Arial, sans-serif',
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#1B4D7C',
    },
    secondary: {
      main: '#2E8B57',
    },
    background: {
      default: '#F8FAFC',
      paper: '#FFFFFF',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <DanielLandingPage />
    </ThemeProvider>
  );
}

export default App;
